import { formatToPriceType } from 'state/secondaryMarket/live/live.selector';
import { formOriginalSelectorsFactory } from 'state/secondaryMarket/shared/form/original/original.selector';
import type { AppState } from 'state/state.model';

import type { SecondaryMarketLiveReloadedForm } from './liveOriginalForm.model';

const selectors = formOriginalSelectorsFactory('live', {});
function select(state: AppState, tabId: string): SecondaryMarketLiveReloadedForm | undefined {
  return state.secondaryMarket.live.form.original[tabId];
}

const getFormCustomizedUpfront = (state: AppState, tabId: string) => select(state, tabId)?.customizedUpfront;

const getFormCustomizedXMarginAdjustment = (state: AppState, tabId: string) =>
  select(state, tabId)?.customizedXMarginAdjustment;

const getFormCustomizedTradingPriceAdjustment = (state: AppState, tabId: string) =>
  select(state, tabId)?.customizedTradingPriceAdjustment;

const getFormSettlementPrice = (state: AppState, tabId: string) => select(state, tabId)?.settlementPrice;

const getFormSettlementPriceByPriceType = (state: AppState, tabId: string) => {
  if (selectors.getPriceType(state, tabId) === 'Percent') {
    return (getFormSettlementPrice(state, tabId) ?? 0) * 100;
  }
  return getFormSettlementPrice(state, tabId);
};

const getFormSettlementPriceFormatted = (state: AppState, tabId: string) => {
  const value = getFormSettlementPrice(state, tabId);
  return formatToPriceType(state, tabId, value);
};

const getFormHasUpfrontFee = (state: AppState, tabId: string) => select(state, tabId)?.hasUpfrontFee;

const getFormTraceReporting = (state: AppState, tabId: string) => select(state, tabId)?.traceReporting;

const getFormXMarginPlusUpfrontFormatted = (state: AppState, tabId: string) => {
  const xMargin = select(state, tabId)?.salesMargin ?? 0;
  const upfront = select(state, tabId)?.upfront ?? 0;
  return formatToPriceType(state, tabId, xMargin + upfront);
};

const getFormAccruedInterestFormatted = (state: AppState, tabId: string) => {
  const accruedInterest = select(state, tabId)?.accruedInterest ?? 0;
  return formatToPriceType(state, tabId, accruedInterest);
};

export const liveOriginalFormSelectors = {
  ...selectors,
  getFormCustomizedUpfront,
  getFormCustomizedXMarginAdjustment,
  getFormCustomizedTradingPriceAdjustment,
  getFormSettlementPrice,
  getFormSettlementPriceByPriceType,
  getFormSettlementPriceFormatted,
  getFormHasUpfrontFee,
  getFormTraceReporting,
  getFormXMarginPlusUpfrontFormatted,
  getFormAccruedInterestFormatted,
};
